import { AncillariesUtilsService } from 'src/app/shared/ib-web-ancillaries-utils';
import angular from 'angular';
import { start } from 'repl';

const controllerInfo = {
    module: 'ib-new-seat-map-module',
    inject: [
        '$scope',
        '$timeout',
        '$rootScope',
        'AncillariesConstants',
        'AncillariesUtilsService',
        'ModalServiceAncillaries',
        '$filter',
        'localStorageService',
        'CurrencyService'
    ],
    required: []
};


export class ibNewFlightMapController implements angular.IController {
    currentPassenger: any;
    seatViewInfo: any;
    isOldConfig: boolean;
    currentPassengerSeat: any;
    seatsModel: any;
    passengers: any;
    aircraftCode: any;

    model: any;
    longHaul: boolean = false;
    seatNum: number;
    aisleNum: number;
    currency: any = this.localStorageService.get('currency');
    seatInfoSelected;
    isInfiniteScroll = false;
    tooltipOpened = false;
    isMobile = this.AncillariesUtilsService.isTouchDevice();

    eventTooltipOpened = this.$rootScope.$on('tooltipOpened', (e, data) => {
        this.tooltipOpened = data;
    });


    constructor (
        private $scope: angular.IScope,
        private $timeout: ng.ITimeoutService,
        private $rootScope: CommonsRootScope,
        private AncillariesConstants: AncillariesConstant,
        private AncillariesUtilsService: AncillariesUtilsService,
        private ModalServiceAncillaries: any,
        private $filter: angular.IFilterService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService
    ) {
        $scope.$on('scrollToSeat', (event, arg) => {
            this.scrollToSeat(this.currentPassenger.currentSeat);
        });
        $scope.$on('updateCabinZones', (event) => {
            this.checkCabinZones();
        });
    }

    $onInit = (): void => {
        let isDisabled = false, i = 0;
        while (!isDisabled && i < this.passengers?.length) {
            if (this.passengers[i].initialSeat.row !== '' || this.passengers[i].initialSeat.column !== '') {
                isDisabled = true;
            }
            i++;
        }

        this.isInfiniteScroll = isDisabled;

    };

    $onChanges (onChangesObj: angular.IOnChangesObject): void {
        this.deleteDoubleSpaces();
        this.checkIfLongHaulType();
        this.checkSeatsAndAislesByColumn();
        this.setCabinsHeight();
        this.checkCabinZones();
    }

    /**
     * Scroll to seat of current passenger in view
     * @param {Object} seat Seat information
     */
    scrollToSeat = (seat) => {
        let auxSeatPreAssigned;
        let id;
        const seatPreAssigned = seat;
        if (seatPreAssigned.rowIndex === 0) {
            id = 'cabins-' + seatPreAssigned?.cabinIndex + '-row-' + seatPreAssigned.rowIndex + '-seat-' + seatPreAssigned.columnIndex;
        } else {
            id = 'cabins-' + seatPreAssigned?.cabinIndex + '-row-' + (seatPreAssigned.rowIndex - 1) + '-seat-' + seatPreAssigned.columnIndex;
        }
        this.$timeout(() => {
            if (id !== null) {
                auxSeatPreAssigned = document.getElementById(id);
                if(!auxSeatPreAssigned || auxSeatPreAssigned.length === 0) {
                    auxSeatPreAssigned = document.getElementById(this.createFirstId(seatPreAssigned.cabinIndex,
                        this.seatsModel.cabins));
                }
                if (auxSeatPreAssigned) {
                    if (seatPreAssigned.rowIndex === 0 && seatPreAssigned.rowIndex === 0) {
                        const rowPreAssigned = auxSeatPreAssigned.parentElement?.parentElement;
                        const cabinPreAssigned = rowPreAssigned.parentElement?.parentElement;
                        cabinPreAssigned.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        const rowPreAssigned = auxSeatPreAssigned.parentElement?.parentElement;
                        rowPreAssigned.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            }
        });
    };

    /**
     * Create first ID
     *
     */
    createFirstId = (index, cabins) => {
        let founded=false, i=0, j=0, k=0, rowIndex=0, columnIndex=0, indexColumn=0;

        while(founded === false) {
            if(cabins[i].enabled) {
                for (j=0; j<cabins[i].columns.length; j++) {
                    if(cabins[i].columns[j].name !=='') {
                        rowIndex=j;
                        j=cabins[i].columns.length;
                    }
                }
                for (j=0; j<cabins[i].seatMap.length; j++) {
                    indexColumn =j;
                    for (k=0; k<cabins[i].seatMap[indexColumn].rowSeats.length; k++) {
                        if(cabins[i].seatMap[indexColumn].rowSeats[k].column !==' ') {
                            columnIndex=k;
                            k=cabins[i].seatMap[indexColumn].rowSeats.length;
                            j=cabins[i].seatMap.length;
                        }
                    }
                }
                founded=true;
            }
            i++;
        }
        return '#cabins-' + index + '-row-' + rowIndex+ '-seat-' + columnIndex;
    };

    /**
     * Check if seat is allowed for current user
     * @param {Array} seatAllowed Array of passengers authorized for seat
     */
    isAllowed = (seatAllowed) => {
        let isAllowed = false;
        if (seatAllowed) {
            isAllowed = seatAllowed.indexOf('' + this.currentPassenger?.id) !== -1;
        }
        return isAllowed;
    };

    /**
     * Change seat of passenger
     * @param {*} seat
     * @param {*} cabinIndex
     * @param {*} rowIndex
     * @param {*} columnIndex
     */
    change = (seat, cabinIndex, rowIndex, columnIndex) => {

        let currentCabin, currentRow, currentColumn;
        if (seat.occupation === this.AncillariesConstants.SEAT_OCCUPATIONS.selection) {
            const modalMessage = this.getModalMessage(seat.modalMessages);
            if (modalMessage !== null) {
                const modalType: any = this.getModalType(modalMessage.type);
                this.ModalServiceAncillaries.openFeatureModal(modalType.templateUrl, modalType.blocked, modalMessage.message, modalType.class).result.then(() => {
                    this.tooltipOpened = false;
                    this.changeSeat(cabinIndex, rowIndex, columnIndex);
                }, () => {
                    this.tooltipOpened = false;
                    currentCabin = this.currentPassenger.currentSeat.cabinIndex;
                    currentRow = this.currentPassenger.currentSeat.rowIndex;
                    currentColumn = this.currentPassenger.currentSeat.columnIndex;
                    this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].occupation = this.AncillariesConstants.SEAT_OCCUPATIONS.free;
                    this.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = this.AncillariesConstants.SEAT_OCCUPATIONS.selection;
                });
            } else {
                if (!this.isMobile) {
                    this.changeSeat(cabinIndex, rowIndex, columnIndex);
                }
            }
        } else {
            const $tooltip = angular.element('.ib-map-tooltip');
            $tooltip.css('display', 'none');
            this.tooltipOpened = false;
        }
    };

    /**
     * Change seat of user
     * @param {Integer} cabinIndex
     * @param {Integer} rowIndex
     * @param {Integer} columnIndex
     */
    deleteSeatSelection = (cabinIndex, rowIndex, columnIndex) => {

        const currentCabin = this.currentPassenger.currentSeat.cabinIndex;
        const currentRow = this.currentPassenger.currentSeat.rowIndex;
        const currentColumn = this.currentPassenger.currentSeat.columnIndex;
        this.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = this.AncillariesConstants.SEAT_OCCUPATIONS.free;
        this.currentPassenger.currentSeat.row = '';
        this.currentPassenger.currentSeat.column = '';
        this.currentPassenger.currentSeat.seatType = '';
        this.currentPassenger.currentSeat.seatTypeDescription = '';
        this.currentPassenger.seatPrice = undefined;
        this.currentPassenger.seatPriceFormatted = '--';
        this.$scope.$emit('deleteSeatSelection', this.currentPassenger.id);
    };

    /**
     * Change seat of user
     * @param {Integer} cabinIndex
     * @param {Integer} rowIndex
     * @param {Integer} columnIndex
     */
    changeSeat = (cabinIndex, rowIndex, columnIndex) => {

        const currentCabin = this.currentPassenger.currentSeat.cabinIndex;
        const currentRow = this.currentPassenger.currentSeat.rowIndex;
        const currentColumn = this.currentPassenger.currentSeat.columnIndex;
        if (currentCabin !== cabinIndex || currentRow !== rowIndex || currentColumn !== columnIndex) {
            this.seatsModel.cabins[currentCabin].seatMap[currentRow].rowSeats[currentColumn].occupation = this.AncillariesConstants.SEAT_OCCUPATIONS.free;
        }
        this.currentPassenger.currentSeat.cabinIndex = cabinIndex;
        this.currentPassenger.currentSeat.rowIndex = rowIndex;
        this.currentPassenger.currentSeat.columnIndex = columnIndex;
        this.currentPassenger.currentSeat.row = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].row;
        this.currentPassenger.currentSeat.column = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].column;
        this.currentPassenger.currentSeat.originalType = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].originalType;
        this.currentPassenger.currentSeat.seatType = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatType;
        this.currentPassenger.currentSeat.seatTypeDescription = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeDescription;
        this.currentPassenger.currentSeat.seatTypeMessasge = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].seatTypeMessasge;
        this.currentPassenger.seatPrice = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].passengersPrice[this.currentPassenger.id];
        this.currentPassenger.seatPriceFormatted = this.seatsModel.cabins[cabinIndex].seatMap[rowIndex].rowSeats[columnIndex].passengersPriceLabels[this.currentPassenger.id];
        this.$scope.$emit('newSeatChange', {
            id: this.currentPassenger.id,
            seat: {
                row: this.currentPassenger.currentSeat.row,
                column: this.currentPassenger.currentSeat.column,
                cabinIndex: cabinIndex,
                rowIndex: rowIndex,
                columnIndex: columnIndex
            },
            price: this.currentPassenger.seatPrice,
            priceFormatted: this.currentPassenger.seatPriceFormatted,
            seatTypeDescription: this.currentPassenger.currentSeat.seatTypeDescription,
            seatType: this.currentPassenger.currentSeat.seatType,
            originalType: this.currentPassenger.currentSeat.originalType,
            seatTypeMessasge: this.currentPassenger.currentSeat.seatTypeMessasge
        });
    };


    /**
    * Open toolTip when click on seat in mobile
    * @param {Object} seat
    * @param {String} cabinIndex
    * @param {String} rowIndex
    * @param {String} seatIndex
    * @param {Object} event
    */
    tooltipTouch = (seat, cabinIndex, rowIndex, seatIndex, event) => {
        if (this.isAllowed(seat.passengersAllowed)) {
            if (!this.isDisabledOccupation(seat.occupation)) {
                this.buildTooltipTouch(seat, cabinIndex, rowIndex, seatIndex, event);
            }
        }
    };

    /**
    * Preview seat and price on passenger
    * @param {Object} seat
    */
    hoverPreview = (seat, event) => {
        if(!this.isMobile &&  seat.passengersAllowed.includes(this.currentPassenger.id.toString()) && seat.occupation === 'FREE') {
            const currentPassengerSeat = {
                row: this.currentPassenger.currentSeat.row,
                column: this.currentPassenger.currentSeat.column,
                seatPrice: this.currentPassenger.seatPrice,
                seatPriceFormatted: this.currentPassenger.seatPriceFormatted,
                occupation: seat.occupation,
                seat: seat
            };
            this.currentPassengerSeat = currentPassengerSeat;

            this.currentPassenger.currentSeat.row = seat.row;
            this.currentPassenger.currentSeat.column = seat.column;
            this.currentPassenger.seatPrice =   seat.passengersPrice[this.currentPassenger.id];
            this.currentPassenger.seatPriceFormatted =   seat.passengersPriceLabels[this.currentPassenger.id];
            seat.occupation = 'SELECTION';
            seat.isPreview = true;
        }
    };

    /**
    * End preview seat and price on passenger
    * @param {Object} seat
    */
    endHoverPreview = (seat, event) => {

        if(!this.isMobile && this.currentPassengerSeat && seat.row === this.currentPassengerSeat.seat.row && seat.column === this.currentPassengerSeat.seat.column) {
            this.currentPassenger.currentSeat.row = this.currentPassengerSeat.row;
            this.currentPassenger.currentSeat.column = this.currentPassengerSeat.column;
            this.currentPassenger.seatPrice = this.currentPassengerSeat.seatPrice;
            this.currentPassenger.seatPriceFormatted = this.currentPassengerSeat.seatPriceFormatted;
            seat.occupation =  this.currentPassengerSeat.occupation;
            this.currentPassengerSeat = undefined;
        }
        seat.isPreview = false;
    };

    zoneToolTipOver = (zoneInfo) => {
        if(!this.isMobile && (!zoneInfo.constantPrice || zoneInfo.hasOverflow)) {
            this.buildZoneToolTipOver(zoneInfo, undefined);
        }
    };

    zoneToolTipClick = (zoneInfo, event) => {
        if(this.isMobile && (!zoneInfo.constantPrice || zoneInfo.hasOverflow)) {
            this.buildZoneToolTipOver(zoneInfo, event);
        }
    };

    buildZoneToolTipOver = (zoneInfo, event) => {
        const titleText = zoneInfo.constantPrice ? zoneInfo.minPrice : this.$filter('translate')('NEW_SEATS_MAP_DIFFERENT_PRICES');

        const tooltip = document.createElement('div');
        tooltip.id = 'zone-tooltip';
        tooltip.className = 'ib-new-map__body-cabin--available-row--group-hover';

        const tooltipContent = document.createElement('div');
        tooltipContent.className = 'ib-new-map__body-cabin--available-row--group-hover-content';

        const title = document.createElement('p');
        title.className = 'ib-new-map__body-cabin--available-row--group-hover-content--title';
        title.textContent = titleText;

        const pointerBody = document.createElement('div');
        pointerBody.className = 'ib-new-map__body-cabin--available-row--group-hover-content--pointer-body';

        tooltipContent.appendChild(title);
        tooltipContent.appendChild(pointerBody);

        if (!zoneInfo.constantPrice) {
            const text = document.createElement('p');
            text.className = 'ib-new-map__body-cabin--available-row--group-hover-content--text';
            text.textContent = this.$filter('translate')('NEW_SEATS_MAP_FROM_TO').replace('#1', zoneInfo.minPrice).replace('#2', zoneInfo.maxPrice);
            tooltipContent.appendChild(text);
        }

        const pointer = document.createElement('div');
        pointer.className = 'ib-new-map__body-cabin--available-row--group-hover--pointer';

        const pointerShadow = document.createElement('div');
        pointerShadow.className = 'ib-new-map__body-cabin--available-row--group-hover--pointer-shadow';

        pointer.appendChild(pointerShadow);

        tooltip.appendChild(pointer);
        tooltip.appendChild(tooltipContent);

        const zoneElement = document.getElementById('zone-' + zoneInfo.zoneIndex);
        if (zoneElement) {
            zoneElement.appendChild(tooltip);
        }

        if(!this.isMobile) {
            zoneElement.addEventListener('mousemove', (event) => {
                const tooltipHeight = tooltip.offsetHeight;
                const zone3Rect = zoneElement.getBoundingClientRect();
                const mouseY = event.clientY - zone3Rect.top;
                tooltip.style.left = (mouseY - tooltipHeight - 104) + 'px';
            });
        } else {
            const tooltipHeight = tooltip.offsetHeight;
            const zone3Rect = zoneElement.getBoundingClientRect();
            const mouseY = event.touches[0].clientY - zone3Rect.top;
            tooltip.style.left = (mouseY - tooltipHeight - 104) + 'px';
        }
    };

    deleteZoneToolTipOver = () => {
        const tooltip = document.getElementById('zone-tooltip');
        if (tooltip) {
            tooltip.parentNode.removeChild(tooltip);
        }
    };

    /**
     * Check if seat is disable
     * @param {String} occupation State of seat
     */
    isDisabledOccupation = (occupation) => {
        return occupation === this.AncillariesConstants.SEAT_OCCUPATIONS.blocked || occupation === this.AncillariesConstants.SEAT_OCCUPATIONS.occupied;
    };

    /**
     * Generate tooltip of seat selected and added to view.
     * @param {Object} seat Seat information
     * @param {Integer} cabinIndex Number of cabin index of seat
     * @param {Integer} rowIndex Number of row
     * @param {Integer} seatIndex Number of seat
     * @param {Object} event Event
     */
    buildTooltipTouch = (seat, cabinIndex, rowIndex, seatIndex, event) => {

        seat.price = this.getPricePassenger(seat, this.currentPassenger.id);
        seat.selectable = this.currentPassenger.issuedSeat === undefined;

        this.ModalServiceAncillaries.openSelectSeatModal({
            seat: seat, seatViewInfo: this.seatViewInfo,
            currentPassenger: this.currentPassenger,
            seatOccupation: this.currentPassengerSeat ? this.currentPassengerSeat.occupation : seat.occupation,
            isOldConfig: this.isOldConfig
        })
            .result.then((selection)=>{
                if(selection) {
                    seat.occupation = 'SELECTION';
                    seat.selectable = true;
                    this.changeSeat(cabinIndex, rowIndex, seatIndex);
                } else {
                    seat.occupation = 'FREE';
                    this.deleteSeatSelection(cabinIndex, rowIndex, seatIndex);
                }
            },
            (reject) => {});

    };

    /**
     * Return price for passenger in seat map
     * @param {Object} seat Information passenger seat
     * @param {Integer} idPassenger Id of passenger for get price
     */
    getPricePassenger = (seat, idPassenger) => {
        return seat.passengersPriceLabels[idPassenger];
    };

    /**
     * Return message of seat returned by service
     * @param {Object} modalMessages
     */
    getModalMessage = (modalMessages) => {
        let found = false, i = 0, modalMessage = null;
        while (!found && i < modalMessages.length) {
            if (modalMessages[i].passengers.indexOf('' + this.currentPassenger.id) !== -1) {
                found = true;
                modalMessage = { message: modalMessages[i].message, type: modalMessages[i].type };
            }
            i++;
        }
        return modalMessage;
    };

    /**
     * Return type modal
     * @param {String} modalType
     */
    getModalType = (modalType) => {
        let modal = {};
        switch (modalType) {
                case this.AncillariesConstants.SeatModalTypes.disclaimer: modal = { templateUrl: 'ib-modal-map-seats-emergency.html', blocked: true, class: 'ib-modals ib-modals--sm' }; break;
                default: modal = { templateUrl: 'ib-modal-seat-map-warning.html', blocked: false, class: 'ib-modals ib-modals--sm' };
        }
        return modal;
    };

    /**
     * Return state of seat
     * @param {Object} seat Seat information
     */
    stateNewSeats = (seat) => {
        let state;
        switch (seat.type) {
                case this.AncillariesConstants.SeatTypes.seat: state = this.generateNewSeatClass(seat); break;
                case this.AncillariesConstants.SeatTypes.gap: seat.column !== ' ' ?
                    state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-unavailable' :
                    state = 'ib-new-map__body-cabin--available-row--column-number'; break;
        }
        return state;
    };

    /**
     * Return class of seat
     * @param {*} seat
     */
    generateNewSeatClass = (seat) => {
        let state;
        switch (seat.occupation) {
                case this.AncillariesConstants.SEAT_OCCUPATIONS.free: state = this.generateFreeNewSeatClass(seat); break;
                case this.AncillariesConstants.SEAT_OCCUPATIONS.selection: state = seat.isPreview ? 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-preview' : 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-selected'; break;
                case this.AncillariesConstants.SEAT_OCCUPATIONS.blocked: state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-blocked'; break;
                case this.AncillariesConstants.SEAT_OCCUPATIONS.occupied: state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-blocked'; break;
                case this.AncillariesConstants.SEAT_OCCUPATIONS.occupiedOtherUser: state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-company'; break;
                default: state = 'ib-new-map__body-cabin--available-row--seat'; break;
        }
        return state;
    };

    generateFreeNewSeatClass = (seat) => {
        let state;
        if (this.isAllowed(seat.passengersAllowed)) {
            state = 'ib-new-map__body-cabin--available-row--seat';
            if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-emergency';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) === -1 && seat.features.indexOf(this.AncillariesConstants.SeatFeatures.extraSize) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-xl';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.infant) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-baby';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(this.AncillariesConstants.SeatFeatures.emergencyExit) === -1) {
                state = 'ib-new-map__body-cabin--available-row--seat';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.promo) !== -1 && seat.features.indexOf(this.AncillariesConstants.SeatFeatures.infant) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-baby';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.upfront) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat';
            } if (seat.features.indexOf(this.AncillariesConstants.SeatFeatures.mobility) !== -1) {
                state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-redux';
            }
        } else {
            state = 'ib-new-map__body-cabin--available-row--seat ib-new-map__body-cabin--available-row--seat-blocked';
        }
        return state;
    };

    getNewSeatText = (seat) => {
        let text = '';
        let haveImage = false;
        seat.features.forEach(feature => {
            if (feature === this.AncillariesConstants.SeatFeatures.mobility || feature === this.AncillariesConstants.SeatFeatures.infant) {
                haveImage = true;
            }
        });
        if(seat.type === 'GAP') {
            if (seat.column === ' ') {
                text = seat.row;
            }
        } else {
            if (seat.occupation === 'OCCUPIED_OTHER_USER') {
                text = this.getUser(seat.column, seat.row);
            } else if (seat.occupation === 'SELECTION') {
                text = this.getCurrentPassenger();
            } else if (seat.occupation === 'FREE' &&  this.isAllowed(seat.passengersAllowed) && !haveImage) {
                if (seat.seatType === this.AncillariesConstants.SeatFeatures.extraSize) {
                    text = 'XL';
                } else if (seat.seatType === this.AncillariesConstants.SeatFeatures.emergencyExit) {
                    text = 'E';
                }
            }
        }

        return text;
    };

    getCurrentPassenger (): string {
        const splitName: string[] = this.currentPassenger.name.split(' ').filter((pieceName: string) => pieceName.length > 0);
        const text = splitName[0].trim().substring(0, 1) + splitName[1].trim().substring(0, 1);
        return text;
    }

    getUser (column: string, row: string): string {
        let text: string;
        this.passengers.forEach((pass: any) => {
            if (pass.currentSeat.row === row && pass.currentSeat.column === column) {
                const splitName: string[] = pass.name.split(' ').filter((pieceName: string) => pieceName.length > 0);
                text = splitName[0].trim().substring(0, 1) + splitName[1].trim().substring(0, 1);
            }
        });
        return text;
    }

    deleteDoubleSpaces = () => {
        this.seatsModel.cabins.forEach(cabin => {
            if (cabin.enabled) {
                cabin.seatMap.forEach(row => {
                    if(row.rowSeats[0].type === 'GAP' && cabin.columns[0].type === 'AISLE') {
                        row.rowSeats[0].doubleAisle = true;
                    }
                    if(row.rowSeats[row.rowSeats.length - 1].type === 'GAP' && cabin.columns[cabin.columns.length - 1].type === 'AISLE') {
                        row.rowSeats[row.rowSeats.length - 1].doubleAisle = true;
                    }
                    for (let i = 1; i < row.rowSeats.length; i++) {
                        if ((row.rowSeats[i].type === 'GAP' && row.rowSeats[i].column === ' ') &&
                                (row.rowSeats[i-1].type === 'GAP' && row.rowSeats[i-1].column === ' ')) {
                            row.rowSeats[i].doubleAisle = true;
                        }
                    }
                });
            }
        });
        this.seatsModel.cabins;
    };

    checkIfLongHaulType = () => {
        this.longHaul = false;
        let longHaulTypes = this.AncillariesConstants.LONG_HAUL_AIRCRAFTS;
        if (this.localStorageService.get('longHaulAircrafts')) {
            longHaulTypes = this.localStorageService.get('longHaulAircrafts');
        }
        if(this.localStorageService.get('aircraftCode')) {
            const aicraftCode: any = this.localStorageService.get('aircraftCode');
            const aircraftInfo = aicraftCode.split('/');
            if (longHaulTypes[aircraftInfo[0]]?.includes(aircraftInfo[1])) {
                this.longHaul = true;
            }
        } else {
            if ( this.aircraftCode?.includes('/') ) {
                const aircraftInfo = this.aircraftCode.split('/');
                if (longHaulTypes[aircraftInfo[0]]?.includes(aircraftInfo[1])) {
                    this.longHaul = true;
                }
            } else {
                if (longHaulTypes.IB.includes(this.aircraftCode)) {
                    this.longHaul = true;
                }
            }
        }
    };

    checkSeatsAndAislesByColumn = () => {
        this.seatNum = 0;
        this.aisleNum = 0;
        this.seatsModel.cabins.forEach(cabin => {
            if (cabin.enabled) {
                for (let i = 0; i < cabin.columns.length; i++) {
                    if (cabin.columns[i].type === 'SEAT') {
                        this.seatNum++;
                    } else if (cabin.columns[i].type === 'AISLE' && cabin.columns[i - 1]?.type !== 'AISLE' && i !== 0 && i !== (cabin.columns.length - 1)) {
                        this.aisleNum++;
                    }
                }
            }
        });
    };

    setCabinsHeight = () => {
        this.$timeout(() => {
            let aircraftInfo: string;
            if ( this.aircraftCode?.includes('/') ) {
                aircraftInfo = this.aircraftCode.split('/');
            } else {
                aircraftInfo = 'IB';
            }
            this.seatsModel.cabins.forEach(cabin => {
                switch(cabin.cabinClass.type) {
                        case this.AncillariesConstants.SEATS_MAP_TOUR.CABINS.business:
                            const businessCabin = document.getElementById('business-cabin');
                            if (businessCabin && aircraftInfo === 'YW') {
                                businessCabin.style.height = this.getHeight(3);
                            } else if (businessCabin && aircraftInfo !== 'YW') {
                                businessCabin.style.height = this.getHeight(7);
                            }
                            break;
                        case this.AncillariesConstants.SEATS_MAP_TOUR.CABINS.premium_tourist:
                            const premiumTouristCabin = document.getElementById('premium-tourist-cabin');
                            if (premiumTouristCabin && aircraftInfo === 'YW') {
                                premiumTouristCabin.style.height = this.getHeight(3);
                            } else if (premiumTouristCabin && aircraftInfo !== 'YW') {
                                premiumTouristCabin.style.height = this.getHeight(4);
                            }
                            break;
                        case this.AncillariesConstants.SEATS_MAP_TOUR.CABINS.economy:
                            const turistCabin = document.getElementById('turist-cabin');
                            if (turistCabin && aircraftInfo === 'YW') {
                                turistCabin.style.height = this.getHeight(20);
                            } else if (turistCabin && aircraftInfo !== 'YW') {
                                turistCabin.style.height = this.getHeight(30);
                            }
                            break;
                }
            });
        });
        this.scrollToSeat(this.currentPassenger?.currentSeat);
    };

    getHeight = (rowNumber) => {
        let cabinHeight;
        if(this.longHaul) {
            cabinHeight= 44;
        } else {
            cabinHeight= 68;
        }
        return (rowNumber * cabinHeight) + 'px';
    };

    checkCabinZones = () => {
        this.$timeout (async () => {
            const zones = [];
            this.seatsModel.cabins.forEach((cabin, cabinIndex) => {
                if (cabin.enabled && cabin.zones && !this.localStorageService.get('oldSeatsConfig')) {
                    const cabinType = cabin.cabinClass.type;
                    const zoneTypes = [];
                    cabin.zones.forEach((zone, index) => {
                        const startingRow = this.getIndexRow(this.seatsModel.cabins[cabinIndex].seatMap, zone.rowInitial);
                        this.seatsModel.cabins[cabinIndex].seatMap[startingRow].zoneStart;
                        const passengerPrices: any = this.getPassengerPrices(zone.passengerPrices, this.currentPassenger.id);
                        const zoneType: any = this.getZoneType(zoneTypes, passengerPrices.priceMin, cabinType);
                        const newZone = {
                            columnLength: this.getColumnLength(zone.rowInitial, zone.rowFinal, cabinIndex),
                            zoneIndex: index,
                            constantPrice: passengerPrices.priceMin === passengerPrices.priceMax,
                            text: this.getZoneText(passengerPrices.priceMin, passengerPrices.priceMin === passengerPrices.priceMax),
                            color: zoneType.color,
                            minPrice: this.CurrencyService.formatPrice(this.currency, passengerPrices.priceMin, false, false, false),
                            maxPrice: this.CurrencyService.formatPrice(this.currency, passengerPrices.priceMax, false, false, false),
                            hasOverflow: false
                        };
                        zones.push(newZone);
                        cabin.seatMap[startingRow].zoneStart = newZone;
                        if (zoneType.newType) {
                            zoneTypes.push(zoneType);
                        }
                    });
                }
            });
            await this.checkOverflowingZones();
            this.addListenerMobile(zones);
        });
    };

    getIndexRow = (seatMap, zoneRowInitial) => {
        let startingRow;
        for (let i = 0; i < seatMap.length; i++) {
            if (parseInt(seatMap[i].row) === zoneRowInitial) {
                startingRow = i;
            }
        }
        return startingRow;
    };

    getZoneType = (zoneTypes, min, cabinType) => {
        let newType = true;
        let typeIndex;
        zoneTypes.forEach((zoneType, index) => {
            if (zoneType.minPrice === min) {
                newType = false;
                typeIndex = index;
            }
        });
        const type = {
            minPrice: min,
            color: newType ? this.AncillariesConstants.SEAT_ZONES_PRICE_COLOR[cabinType][zoneTypes.length] : zoneTypes[typeIndex].color,
            newType: newType
        };
        return type;
    };

    getPassengerPrices = (zonePrices, passengerId) => {
        const flowApp = this.localStorageService.get('flowApp');
        let passengerPrices;
        if (flowApp === 'CKI' || flowApp === 'ECKI') {
            zonePrices.forEach(passPrices => {
                if (parseInt(passPrices.id) === passengerId) {
                    passengerPrices = passPrices;
                }
            });
        } else {
            zonePrices.forEach(passPrices => {
                if (passPrices.id === passengerId) {
                    passengerPrices = passPrices;
                }
            });
        }
        return passengerPrices;
    };

    getColumnLength = (initial, final, cabinIndex) => {
        const initialRow = this.getIndexRow(this.seatsModel.cabins[cabinIndex].seatMap, initial);
        const finalRow = this.getIndexRow(this.seatsModel.cabins[cabinIndex].seatMap, final);
        const zoneLength = finalRow - initialRow;
        const length = this.longHaul ? ((44 * (zoneLength)) + 40) : ((68 * (zoneLength)) + 60);
        return length + 'px';
    };

    getZoneText = (min, constantPrice) => {
        let text = constantPrice ? '#' : this.$filter('translate')('DEFAULT_FROM_PRICE');
        text = text.replace('#', this.CurrencyService.formatPrice(this.currency, min, false, false, false));
        return text;
    };

    checkOverflowingZones = () => {
        this.$timeout (() => {
            this.seatsModel.cabins.forEach((cabin) => {
                if (cabin.enabled && cabin.zones) {
                    let zoneIndex = 0;
                    cabin.seatMap.forEach((seatRow) => {
                        if (seatRow.zoneStart) {
                            const zoneElement = document.getElementById('zone-' + zoneIndex);
                            const zoneContainter = zoneElement.querySelector('p');
                            const zoneContent = zoneElement.querySelector('p');
                            if (zoneContent.scrollWidth > zoneContainter.clientWidth) {
                                seatRow.zoneStart.text = this.$filter('translate')('DEFAULT_SEE_TEXT');
                                seatRow.zoneStart.hasOverflow = true;
                            }
                            zoneIndex++;
                        }
                    });
                }
            });
        });
    };

    addListenerMobile = (zones: any[]) => {
        if (this.isMobile && zones.length > 0) {
            for (let i = 0; i < zones.length; i++) {
                if (!zones[i].constantPrice) {
                    const id = 'zone-' + zones[i].zoneIndex;
                    const el: HTMLElement = document.getElementById(id);
                    el?.addEventListener('touchstart', (event) => {
                        this.zoneToolTipClick(zones[i], event);
                    });
                    el?.addEventListener('touchend', () => {
                        this.deleteZoneToolTipOver();
                    });
                    el?.addEventListener('contextmenu', (event) => {
                        event.preventDefault();
                    });
                }
            }
        }
    };
}

try {
    ibNewFlightMapController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ibNewFlightMapController.name, ibNewFlightMapController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ibNewFlightMapController.$inject = controllerInfo.inject;
    mod.controller(ibNewFlightMapController.name, ibNewFlightMapController);
}
